var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFuelTypeEco32 = function SvgFuelTypeEco32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 8h19M11.006 8H26v6.416c0 2.012-.79 3.94-2.197 5.363A7.458 7.458 0 0 1 18.5 22v0a7.458 7.458 0 0 1-5.303-2.221A7.627 7.627 0 0 1 11 14.416V8h.006ZM15 2v6m7-6v6M3.5 30h10.783c.556 0 1.106-.104 1.618-.305a4.24 4.24 0 0 0 1.37-.867 3.97 3.97 0 0 0 .914-1.296c.21-.485.318-1.005.315-1.529V23",
    stroke: "currentColor",
    strokeWidth: 1.931,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20.73 13.894-2.704 5.37a.195.195 0 0 1-.08.09.184.184 0 0 1-.116.024.214.214 0 0 1-.171-.084.231.231 0 0 1-.047-.19l.502-3.284a.227.227 0 0 0-.053-.177.212.212 0 0 0-.165-.072h-1.743a.217.217 0 0 1-.109-.03.23.23 0 0 1-.113-.195.24.24 0 0 1 .025-.115L18.66 9.84a.198.198 0 0 1 .081-.09.187.187 0 0 1 .116-.024.214.214 0 0 1 .171.084.234.234 0 0 1 .047.19l-.503 3.285a.248.248 0 0 0 .052.185.232.232 0 0 0 .166.085h1.744a.211.211 0 0 1 .111.027.23.23 0 0 1 .084.083.233.233 0 0 1 .001.23Z",
    fill: "currentColor"
  })));
};
export default SvgFuelTypeEco32;